import React, { useEffect, useRef, useState } from "react";
import ReactTooltip from "react-tooltip";
import Editor from "ckeditor5-custom-build/build/ckeditor";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import { removeAllTags } from "../../../config/utils";
import { DYNAMIC_FIELD_TYPES } from "../../common/constants";
import { editorConfiguration } from "../../../utils/ckEditorUtils";
import moment from "moment";
import NumberFormat from "react-number-format";
import CopyToClipboard from "react-copy-to-clipboard";

const AssetBand = ({
    mainFields,
    restFields,
    band,
    index,
    setShowRichTextPopup,
    basicDetails,
    bandKey,
    isInaccessible,
    isDefaultOpen,
    keys = "",
    isSyncedRestoreModal = false,
    isCurrentValue = false,
    hideNewText = false,
    fieldSearch = ""
}) => {
    const fromValueStyle = {
        backgroundColor: "#ffe6e6",
        padding: "4px",
        borderRadius: "3px",
        marginBottom: "5px"
    };

    const toValueStyle = {
        backgroundColor: "#e6ffe6",
        padding: "4px",
        borderRadius: "3px"
    };
    const bandRef = useRef(null);

    const divCounts = 4;
    const outerDivCount = Math.ceil(Object.keys(restFields ?? {})?.length / divCounts);

    const getRestoreStyle = elem =>
        isSyncedRestoreModal ? (isCurrentValue && elem?.is_change ? fromValueStyle : !isCurrentValue && elem?.is_change ? toValueStyle : {}) : {};
    const renderHighlightedLabel = labelValue => {
        const query = fieldSearch?.trim();
        const labelText = labelValue ?? "";
        if (!query) return labelText;

        return labelText.split(new RegExp(`(${query})`, "ig")).map((part, index) =>
            part.toLowerCase() === query.toLowerCase() ? (
                <span key={`${part}-${index}`} className="asset-field-search-label">
                    {part}
                </span>
            ) : (
                part
            )
        );
    };

    return (
        <>
            <ReactTooltip id="Asset_details" effect="solid" className="rc-tooltip-custom-class" backgroundColor="#007bff" html />

            <div className="cnt-sec" ref={bandRef}>
                <div className="card ml-0">
                    <div class="card-header" id={keys ? `heading-${keys}-${index + 1}` : `heading-${index + 1}`}>
                        <div className="outer-rcm recommendations otr-recom-div">
                            <button
                                class="btn btn-link"
                                data-toggle="collapse"
                                data-target={keys ? `#collapse-${keys}-${index + 1}` : `#collapse-${index + 1}`}
                                aria-expanded={isDefaultOpen || index === 100 ? "true" : "false"}
                                aria-controls={keys ? `collapse-${keys}-${index + 1}` : `collapse-${index + 1}`}
                            >
                                {band}
                            </button>
                            {Object.keys(mainFields).map((eachField, idx) => (
                                <div
                                    className={`${isInaccessible ? "txt-rcm mob-asset" : "txt-rcm"}  `}
                                    data-tip={
                                        ![DYNAMIC_FIELD_TYPES.MEMO, DYNAMIC_FIELD_TYPES.DATE].includes(mainFields?.[eachField]?.field_type)
                                            ? mainFields?.[eachField]?.value
                                                ? mainFields?.[eachField]?.value?.toString()?.length > 20
                                                    ? mainFields?.[eachField]?.value?.toString()
                                                    : ""
                                                : basicDetails?.[eachField]
                                                  ? basicDetails?.[eachField]?.toString()?.length > 20
                                                      ? basicDetails?.[eachField]?.toString()
                                                      : ""
                                                  : ""
                                            : ""
                                    }
                                    data-multiline={true}
                                    data-place="left"
                                    data-for="Asset_details"
                                    data-effect="solid"
                                    data-background-color="#4991ff"
                                >
                                    <div className="txt-dtl content-inp-card">
                                        {mainFields?.[eachField]?.field_type === DYNAMIC_FIELD_TYPES.MEMO ? (
                                            <div class="expand-window-icon">
                                                <h4>{renderHighlightedLabel(mainFields?.[eachField]?.label)}</h4>
                                                <button
                                                    class="butn-expansion"
                                                    data-for="input_field"
                                                    data-tip="Expand Field"
                                                    onClick={e => {
                                                        e.preventDefault();
                                                        setShowRichTextPopup({
                                                            show: true,
                                                            label: mainFields?.[eachField]?.label,
                                                            value: mainFields?.[eachField]?.value,
                                                            key: mainFields?.[eachField]?.field_name
                                                        });
                                                    }}
                                                >
                                                    <img src="/img/expand1.svg" alt="" />
                                                </button>
                                            </div>
                                        ) : mainFields?.[eachField]?.invalid && mainFields?.[eachField]?.value ? (
                                            <div className="d-flex">
                                                <h4>{renderHighlightedLabel(mainFields?.[eachField]?.label)}</h4>
                                                {mainFields?.[eachField]?.invalid && !hideNewText && <span className="new-span-badge">New</span>}
                                            </div>
                                        ) : (
                                            <div>
                                                <h4 className="mb-0">{renderHighlightedLabel(mainFields?.[eachField]?.label)}</h4>
                                            </div>
                                        )}
                                        {mainFields?.[eachField]?.field_type === DYNAMIC_FIELD_TYPES.MEMO ? (
                                            <div style={getRestoreStyle(mainFields?.[eachField])}>
                                                <CKEditor
                                                    editor={Editor}
                                                    config={{ ...editorConfiguration, toolbar: [] }}
                                                    data={mainFields?.[eachField]?.value ?? ""}
                                                    onReady={editor => {
                                                        editor?.setData(mainFields?.[eachField]?.value ? mainFields?.[eachField]?.value : "");
                                                        editor?.enableReadOnlyMode("my-feature-id");
                                                    }}
                                                />
                                            </div>
                                        ) : mainFields?.[eachField]?.field_type === DYNAMIC_FIELD_TYPES.BOOLEAN ? (
                                            <h3 style={getRestoreStyle(mainFields?.[eachField])}>{mainFields?.[eachField]?.value ? "Yes" : "No"}</h3>
                                        ) : mainFields?.[eachField]?.field_type === DYNAMIC_FIELD_TYPES.DATE ? (
                                            <h3 style={getRestoreStyle(mainFields?.[eachField])}>
                                                {mainFields?.[eachField]?.value
                                                    ? moment(mainFields?.[eachField]?.value).format("MM-DD-YYYY")
                                                    : basicDetails?.[eachField]
                                                      ? moment(basicDetails?.[eachField]).format("MM-DD-YYYY h:mm A")
                                                      : "-"}
                                            </h3>
                                        ) : mainFields?.[eachField]?.field_type === DYNAMIC_FIELD_TYPES.COLOR ? (
                                            <h3 className="d-flex align-items-center" style={getRestoreStyle(mainFields?.[eachField])}>
                                                {mainFields?.[eachField]?.value || "-"}
                                                <span
                                                    className="color-box-common"
                                                    style={{
                                                        background: mainFields?.[eachField]?.value ? `${mainFields?.[eachField]?.value}` : "#fff"
                                                    }}
                                                ></span>
                                            </h3>
                                        ) : [DYNAMIC_FIELD_TYPES.NUMBER, DYNAMIC_FIELD_TYPES.CURRENCY].includes(
                                              mainFields?.[eachField]?.field_type
                                          ) ? (
                                            mainFields?.[eachField]?.value || mainFields?.[eachField]?.value === 0 ? (
                                                <NumberFormat
                                                    autoComplete={"off"}
                                                    thousandSeparator={mainFields?.[eachField]?.rules?.thousand_separator}
                                                    prefix={mainFields?.[eachField]?.rules?.prefix}
                                                    suffix={mainFields?.[eachField]?.rules?.suffix}
                                                    decimalScale={mainFields?.[eachField]?.rules?.decimal_scale}
                                                    value={mainFields?.[eachField]?.value ? mainFields?.[eachField]?.value : "-"}
                                                    format={mainFields?.[eachField]?.rules?.format}
                                                    disabled
                                                    allowNegative={mainFields?.[eachField]?.rules?.allow_negative}
                                                    displayType={"text"}
                                                    style={getRestoreStyle(mainFields?.[eachField])}
                                                />
                                            ) : (
                                                <h3 style={getRestoreStyle(mainFields?.[eachField])}>-</h3>
                                            )
                                        ) : (
                                            <>
                                                <h3 style={getRestoreStyle(mainFields?.[eachField])}>
                                                    {mainFields?.[eachField]?.value
                                                        ? mainFields?.[eachField]?.value?.toString().length > 20
                                                            ? removeAllTags(mainFields?.[eachField]?.value?.toString()).substring(0, 20) + "..."
                                                            : removeAllTags(mainFields?.[eachField]?.value?.toString()) || "-"
                                                        : basicDetails?.[eachField]?.toString().length > 20
                                                          ? removeAllTags(basicDetails?.[eachField]?.toString()).substring(0, 20) + "..."
                                                          : removeAllTags(basicDetails?.[eachField]?.toString()) || "-"}
                                                </h3>
                                            </>
                                        )}
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                    <div
                        id={keys ? `collapse-${keys}-${index + 1}` : `collapse-${index + 1}`}
                        class={isDefaultOpen || index === 100 ? "collapse show" : "collapse"}
                        aria-labelledby={keys ? `heading-${keys}-${index + 1}` : `heading-${index + 1}`}
                    >
                        <div class="card-body">
                            {Array.from({ length: outerDivCount }).map((_, index) => {
                                const start = index * divCounts;
                                const end = start + divCounts;
                                const chunk = Object.keys(restFields ?? {}).slice(start, end);
                                return (
                                    <div key={index + 1} className="outer-rcm recommendations">
                                        {chunk.map((eachRestField, idx) => (
                                            <div
                                                className={`${bandKey === "survey_details" ? "txt-rcm mob-asset" : "txt-rcm"} `}
                                                data-tip={
                                                    ![DYNAMIC_FIELD_TYPES.MEMO, DYNAMIC_FIELD_TYPES.DATE].includes(
                                                        restFields?.[eachRestField]?.field_type
                                                    )
                                                        ? restFields?.[eachRestField]?.value
                                                            ? restFields?.[eachRestField]?.value?.toString()?.length > 20
                                                                ? restFields?.[eachRestField]?.value?.toString()
                                                                : ""
                                                            : basicDetails?.[eachRestField]
                                                              ? basicDetails?.[eachRestField]?.toString()?.length > 20
                                                                  ? basicDetails?.[eachRestField]?.toString()
                                                                  : ""
                                                              : ""
                                                        : ""
                                                }
                                                data-multiline={true}
                                                data-place="left"
                                                data-for="Asset_details"
                                                data-effect="solid"
                                                data-background-color="#4991ff"
                                            >
                                                <div className="txt-dtl content-inp-card">
                                                    {restFields?.[eachRestField]?.field_type === DYNAMIC_FIELD_TYPES.MEMO ? (
                                                        <div className="expand-window-icon ckeditor-band">
                                                            <h4>{renderHighlightedLabel(restFields?.[eachRestField]?.label)}</h4>
                                                            <button
                                                                class="butn-expansion"
                                                                data-for="input_field"
                                                                data-tip="Expand Field"
                                                                onClick={e => {
                                                                    e.preventDefault();
                                                                    setShowRichTextPopup({
                                                                        show: true,
                                                                        label: restFields?.[eachRestField]?.label,
                                                                        value: restFields?.[eachRestField]?.value,
                                                                        key: restFields?.[eachRestField]?.field_name
                                                                    });
                                                                }}
                                                            >
                                                                <img src="/img/expand1.svg" alt="" />
                                                            </button>
                                                        </div>
                                                    ) : restFields?.[eachRestField]?.invalid && restFields?.[eachRestField]?.value ? (
                                                        <div className="d-flex">
                                                            <h4>{renderHighlightedLabel(restFields?.[eachRestField]?.label)}</h4>
                                                            {restFields?.[eachRestField]?.invalid && !hideNewText && (
                                                                <span className="new-span-badge">New</span>
                                                            )}
                                                        </div>
                                                    ) : (
                                                        <div>
                                                            <h4 className="mb-0">{renderHighlightedLabel(restFields?.[eachRestField]?.label)}</h4>
                                                        </div>
                                                    )}

                                                    {restFields?.[eachRestField]?.field_type === DYNAMIC_FIELD_TYPES.MEMO ? (
                                                        <div style={getRestoreStyle(restFields?.[eachRestField])}>
                                                            <CKEditor
                                                                editor={Editor}
                                                                config={{ ...editorConfiguration, toolbar: [] }}
                                                                data={restFields?.[eachRestField]?.value ?? ""}
                                                                onReady={editor => {
                                                                    editor?.setData(
                                                                        restFields?.[eachRestField]?.value ? restFields?.[eachRestField]?.value : ""
                                                                    );
                                                                    editor?.enableReadOnlyMode("my-feature-id");
                                                                }}
                                                            />
                                                        </div>
                                                    ) : restFields?.[eachRestField]?.field_type === DYNAMIC_FIELD_TYPES.BOOLEAN ? (
                                                        <h3 style={getRestoreStyle(restFields?.[eachRestField])}>
                                                            {restFields?.[eachRestField]?.value
                                                                ? restFields?.[eachRestField]?.value
                                                                    ? "Yes"
                                                                    : "No"
                                                                : basicDetails?.[eachRestField]
                                                                  ? "Yes"
                                                                  : "No"}
                                                        </h3>
                                                    ) : restFields?.[eachRestField]?.field_type === DYNAMIC_FIELD_TYPES.DATE ? (
                                                        <h3 style={getRestoreStyle(restFields?.[eachRestField])}>
                                                            {restFields?.[eachRestField]?.value
                                                                ? moment(restFields?.[eachRestField]?.value).format("MM-DD-YYYY")
                                                                : basicDetails?.[eachRestField]
                                                                  ? moment(basicDetails?.[eachRestField]).format("MM-DD-YYYY h:mm A")
                                                                  : "-"}
                                                        </h3>
                                                    ) : restFields?.[eachRestField]?.field_type === DYNAMIC_FIELD_TYPES.DATE_TIME ? (
                                                        <h3 style={getRestoreStyle(restFields?.[eachRestField])}>
                                                            {restFields?.[eachRestField]?.value
                                                                ? moment(restFields?.[eachRestField]?.value).format("MM-DD-YYYY  h:mm A")
                                                                : "-"}
                                                        </h3>
                                                    ) : [DYNAMIC_FIELD_TYPES.NUMBER, DYNAMIC_FIELD_TYPES.CURRENCY].includes(
                                                          restFields?.[eachRestField]?.field_type
                                                      ) ? (
                                                        restFields?.[eachRestField]?.value ? (
                                                            <NumberFormat
                                                                autoComplete={"off"}
                                                                thousandSeparator={restFields?.[eachRestField]?.rules?.thousand_separator}
                                                                prefix={restFields?.[eachRestField]?.rules?.prefix}
                                                                suffix={restFields?.[eachRestField]?.rules?.suffix}
                                                                decimalScale={restFields?.[eachRestField]?.rules?.decimal_scale}
                                                                value={restFields?.[eachRestField]?.value ?? ""}
                                                                format={restFields?.[eachRestField]?.rules?.format}
                                                                disabled
                                                                allowNegative={restFields?.[eachRestField]?.rules?.allow_negative}
                                                                displayType={"text"}
                                                                style={getRestoreStyle(restFields?.[eachRestField])}
                                                            />
                                                        ) : (
                                                            <h3 style={getRestoreStyle(restFields?.[eachRestField])}>-</h3>
                                                        )
                                                    ) : (
                                                        <>
                                                            <h3 style={getRestoreStyle(restFields?.[eachRestField])}>
                                                                {restFields?.[eachRestField]?.value
                                                                    ? restFields?.[eachRestField]?.value?.toString().length > 20
                                                                        ? removeAllTags(restFields?.[eachRestField]?.value?.toString()).substring(
                                                                              0,
                                                                              20
                                                                          ) + "..."
                                                                        : removeAllTags(restFields?.[eachRestField]?.value?.toString()) || "-"
                                                                    : basicDetails?.[eachRestField]?.toString().length > 20
                                                                      ? removeAllTags(basicDetails?.[eachRestField]?.toString()).substring(0, 20) +
                                                                        "..."
                                                                      : removeAllTags(basicDetails?.[eachRestField]?.toString()) || "-"}
                                                            </h3>
                                                        </>
                                                    )}
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default AssetBand;
